import { OnboardingTrialFlag } from '@sdk/authentication/types/apiTypes';

export const getCompletionPercentage = (steps: OnboardingTrialFlag[]): number => {
  if (!steps.length) {
    return 0;
  }

  const stepsCompleted = steps.filter((step) => step.completed).length;
  const allSteps = steps.length;

  return (stepsCompleted / allSteps) * 100;
};
